//Font Awesome Icons
export const Icondata1 = [
    { id: 1, className: 'fab fa-500px', tooltip: 'fab fa-500px' },
    { id: 2, className: 'fa fa-address-book', tooltip: 'fa fa-address-book' },
    { id: 3, className: 'far fa-address-book', tooltip: 'far fa-address-book' },
    { id: 4, className: 'fa fa-address-card', tooltip: 'fa fa-address-card' },
    { id: 5, className: 'far fa-address-card', tooltip: 'far fa-address-card' },
    { id: 6, className: 'fa fa-adjust', tooltip: 'fa fa-adjust' },
    { id: 7, className: 'fab fa-adn', tooltip: 'fab fa-adn' },
    { id: 8, className: 'fa fa-align-center', tooltip: 'fa fa-align-center' },
    { id: 9, className: 'fa fa-align-justify', tooltip: 'fa fa-align-justify' },
    { id: 10, className: 'fa fa-align-left', tooltip: 'fa fa-align-left' },
    { id: 11, className: 'fa fa-align-right', tooltip: 'fa fa-align-right' },
    { id: 12, className: 'fab fa-amazon', tooltip: 'fab fa-amazon' },
    { id: 13, className: 'fa fa-ambulance', tooltip: 'fa fa-ambulance' },
    { id: 14, className: 'fa fa-american-sign-language-interpreting', tooltip: 'fa fa-american-sign-language-interpreting' },
    { id: 15, className: 'fa fa-anchor', tooltip: 'fa fa-anchor' },
    { id: 16, className: 'fab fa-android', tooltip: 'fab fa-android' },
    { id: 17, className: 'fab fa-angellist', tooltip: 'fab fa-angellist' },
    { id: 18, className: 'fa fa-angle-double-down', tooltip: 'fa fa-angle-double-down' },
    { id: 19, className: 'fa fa-angle-double-left', tooltip: 'fa fa-angle-double-left' },
    { id: 20, className: 'fa fa-angle-double-right', tooltip: 'fa fa-angle-double-right' },
    { id: 21, className: 'fa fa-angle-double-up', tooltip: 'fa fa-angle-double-up' }
]
//Material Design Icons
export const Icondata2 = [
    { id: 1, className: 'mdi mdi-access-point', tooltip: 'mdi mdi-access-point' },
    { id: 2, className: 'mdi mdi-access-point-network', tooltip: 'mdi mdi-access-point-network' },
    { id: 3, className: 'mdi mdi-account', tooltip: 'mdi mdi-account' },
    { id: 4, className: 'mdi mdi-account-alert', tooltip: 'mdi mdi-account-alert' },
    { id: 5, className: 'mdi mdi-account-box', tooltip: 'mdi mdi-account-box' },
    { id: 6, className: 'mdi mdi-account-box-outline', tooltip: 'mdi mdi-account-box-outline' },
    { id: 7, className: 'mdi mdi-account-card-details', tooltip: 'mdi mdi-account-card-details' },
    { id: 8, className: 'mdi mdi-account-check', tooltip: 'mdi mdi-account-check' },
    { id: 9, className: 'mdi mdi-account-circle', tooltip: 'mdi mdi-account-circle' },
    { id: 10, className: 'mdi mdi-account-convert', tooltip: 'mdi mdi-account-convert' },
    { id: 11, className: 'mdi mdi-account-edit', tooltip: 'mdi mdi-account-edit' },
    { id: 12, className: 'mdi mdi-account-key', tooltip: 'mdi mdi-account-key' },
    { id: 13, className: 'mdi mdi-account-location', tooltip: 'mdi mdi-account-location' },
    { id: 14, className: 'mdi mdi-account-minus', tooltip: 'mdi mdi-account-minus' },
    { id: 15, className: 'mdi mdi-account-multiple', tooltip: 'mdi mdi-account-multiple' },
    { id: 16, className: 'mdi mdi-account-multiple-minus', tooltip: 'mdi mdi-account-multiple-minus' },
    { id: 17, className: 'mdi mdi-account-multiple-outline', tooltip: 'mdi mdi-account-multiple-outline' },
    { id: 18, className: 'mdi mdi-account-multiple-plus', tooltip: 'mdi mdi-account-multiple-plus' },
    { id: 19, className: 'mdi mdi-account-network', tooltip: 'mdi mdi-account-network' },
    { id: 20, className: 'mdi mdi-account-off', tooltip: 'mdi mdi-account-off' },
    { id: 21, className: 'mdi mdi-account-outline', tooltip: 'mdi mdi-account-outline' }
]
//Simple Line Icons
export const Icondata3 = [
    { id: 1, className: 'si si-user', tooltip: 'si si-user' },
    { id: 2, className: 'si si-people', tooltip: 'si si-people' },
    { id: 3, className: 'si si-user-female', tooltip: 'si si-user-female' },
    { id: 4, className: 'si si-user-follow', tooltip: 'si si-user-follow' },
    { id: 5, className: 'si si-user-following', tooltip: 'si si-user-following' },
    { id: 6, className: 'si si-user-unfollow', tooltip: 'si si-user-unfollow' },
    { id: 7, className: 'si si-login', tooltip: 'si si-login' },
    { id: 8, className: 'si si-logout', tooltip: 'si si-logout' },
    { id: 9, className: 'si si-emotsmile', tooltip: 'si si-emotsmile' },
    { id: 10, className: 'si si-phone', tooltip: 'si si-phone' },
    { id: 11, className: 'si si-call-end', tooltip: 'si si-call-end' },
    { id: 12, className: 'si si-call-in', tooltip: 'si si-call-in' },
    { id: 13, className: 'si si-call-out', tooltip: 'si si-call-out' },
    { id: 14, className: 'si si-map', tooltip: 'si si-map' },
    { id: 15, className: 'si si-location-pin', tooltip: 'si si-location-pin' },
    { id: 16, className: 'si si-direction', tooltip: 'si si-direction' },
    { id: 17, className: 'si si-directions', tooltip: 'si si-directions' },
    { id: 18, className: 'si si-compass', tooltip: 'si si-compass' },
    { id: 19, className: 'si si-layers', tooltip: 'si si-layers' },
    { id: 20, className: 'si si-menu', tooltip: 'si si-menu' },
    { id: 21, className: 'si si-list', tooltip: 'si si-list' }
]
//Feather Icons
export const Icondata4 = [
    { id: 1, className: 'fe fe-activity', tooltip: 'fe fe-activity' },
    { id: 2, className: 'fe fe-airplay', tooltip: 'fe fe-airplay' },
    { id: 3, className: 'fe fe-alert-circle', tooltip: 'fe fe-alert-circle' },
    { id: 4, className: 'fe fe-alert-triangle', tooltip: 'fe fe-alert-triangle' },
    { id: 5, className: 'fe fe-bar-chart-2', tooltip: 'fe fe-bar-chart-2' },
    { id: 6, className: 'fe fe-bell', tooltip: 'fe fe-bell' },
    { id: 7, className: 'fe fe-camera', tooltip: 'fe fe-camera' },
    { id: 8, className: 'fe fe-copy', tooltip: 'fe fe-copy' },
    { id: 9, className: 'fe fe-eye', tooltip: 'fe fe-eye' },
    { id: 10, className: 'fe fe-file', tooltip: 'fe fe-file' },
    { id: 11, className: 'fe fe-layout', tooltip: 'fe fe-layout' },
    { id: 12, className: 'fe fe-cpu', tooltip: 'fe fe-cpu' },
    { id: 13, className: 'fe fe-mic', tooltip: 'fe fe-mic' },
    { id: 14, className: 'fe fe-disc', tooltip: 'fe fe-disc' },
    { id: 15, className: 'fe fe-feather', tooltip: 'fe fe-feather' },
    { id: 16, className: 'fe fe-file-minus', tooltip: 'fe fe-file-minus' },
    { id: 17, className: 'fe fe-folder', tooltip: 'fe fe-folder' },
    { id: 18, className: 'fe fe-home', tooltip: 'fe fe-home' },
    { id: 19, className: 'fe fe-image', tooltip: 'fe fe-image' },
    { id: 20, className: 'fe fe-map-pin', tooltip: 'fe fe-map-pin' },
    { id: 21, className: 'fe fe-moon', tooltip: 'fe fe-moon' },
    { id: 22, className: 'fe fe-settings', tooltip: 'fe fe-settings' }
]
//Ionic Icons
export const Icondata5 = [
    { id: 1, className: 'icon ion-md-alarm', tooltip: 'icon ion-md-alarm' },
    { id: 2, className: 'icon ion-md-chatboxes', tooltip: 'icon ion-md-chatboxes' },
    { id: 3, className: 'icon ion-md-copy', tooltip: 'icon ion-md-copy' },
    { id: 4, className: 'icon ion-md-cube', tooltip: 'icon ion-md-cube' },
    { id: 5, className: 'icon ion-md-filing', tooltip: 'icon ion-md-filing' },
    { id: 6, className: 'icon ion-md-eye', tooltip: 'icon ion-md-eye' },
    { id: 7, className: 'icon ion-md-globe', tooltip: 'icon ion-md-globe' },
    { id: 8, className: 'icon ion-md-images', tooltip: 'icon ion-md-images' },
    { id: 9, className: 'icon ion-md-laptop', tooltip: 'icon ion-md-laptop' },
    { id: 10, className: 'icon ion-md-paper', tooltip: 'icon ion-md-paper' },
    { id: 11, className: 'icon ion-md-paper-plane', tooltip: 'icon ion-md-paper-plane' },
    { id: 12, className: 'icon ion-md-pricetags', tooltip: 'icon ion-md-pricetags' },
    { id: 13, className: 'icon ion-ios-settings', tooltip: 'icon ion-ios-settings' },
    { id: 14, className: 'icon ion-ios-stats', tooltip: 'icon ion-ios-stats' },
    { id: 15, className: 'icon ion-ios-share-alt', tooltip: 'icon ion-ios-share-alt' },
    { id: 16, className: 'icon ion-ios-rocket', tooltip: 'icon ion-ios-rocket' },
    { id: 17, className: 'icon ion-ios-rainy', tooltip: 'icon ion-ios-rainy' },
    { id: 18, className: 'icon ion-ios-print', tooltip: 'icon ion-ios-print' },
    { id: 19, className: 'icon ion-ios-pie', tooltip: 'icon ion-ios-pie' },
    { id: 20, className: 'icon ion-ios-mic', tooltip: 'icon ion-ios-mic' },
    { id: 21, className: 'icon ion-ios-locate', tooltip: 'icon ion-ios-locate' }
]
//Themify Icons
export const Icondata6 = [
    { id: 1, className: 'ti-arrow-up', tooltip: 'ti-arrow-up' },
    { id: 2, className: 'ti-arrow-right', tooltip: 'ti-arrow-right' },
    { id: 3, className: 'ti-arrow-left', tooltip: 'ti-arrow-left' },
    { id: 4, className: 'ti-arrow-down', tooltip: 'ti-arrow-down' },
    { id: 5, className: 'ti-arrows-vertical', tooltip: 'ti-arrows-vertical' },
    { id: 6, className: 'ti-arrows-horizontal', tooltip: 'ti-arrows-horizontal' },
    { id: 7, className: 'ti-angle-up', tooltip: 'ti-angle-up' },
    { id: 8, className: 'ti-angle-right', tooltip: 'ti-angle-right' },
    { id: 9, className: 'ti-angle-left', tooltip: 'ti-angle-left' },
    { id: 10, className: 'ti-angle-down', tooltip: 'ti-angle-down' },
    { id: 11, className: 'ti-angle-double-up', tooltip: 'ti-angle-double-up' },
    { id: 12, className: 'ti-angle-double-right', tooltip: 'ti-angle-double-right' },
    { id: 13, className: 'ti-angle-double-left', tooltip: 'ti-angle-double-left' },
    { id: 14, className: 'ti-angle-double-down', tooltip: 'ti-angle-double-down' },
    { id: 15, className: 'ti-move', tooltip: 'ti-move' },
    { id: 16, className: 'ti-fullscreen', tooltip: 'ti-fullscreen' },
    { id: 17, className: 'ti-arrow-top-right', tooltip: 'ti-arrow-top-right' },
    { id: 18, className: 'ti-arrow-top-left', tooltip: 'ti-arrow-top-left' },
    { id: 19, className: 'ti-arrow-circle-up', tooltip: 'ti-arrow-circle-up' },
    { id: 20, className: 'ti-arrow-circle-right', tooltip: 'ti-arrow-circle-right' },
    { id: 21, className: 'ti-arrow-circle-left', tooltip: 'ti-arrow-circle-left' }
]
//Typicon Icons
export const Icondata7 = [
    { id: 1, className: 'typcn typcn-chart-pie-outline', tooltip: 'typcn typcn-chart-pie-outline' },
    { id: 2, className: 'typcn typcn-chart-pie', tooltip: 'typcn typcn-chart-pie' },
    { id: 3, className: 'typcn typcn-chevron-left', tooltip: 'typcn typcn-chevron-left' },
    { id: 4, className: 'typcn typcn-chevron-left-outline', tooltip: 'typcn typcn-chevron-left-outline' },
    { id: 5, className: 'typcn typcn-chevron-right-outline', tooltip: 'typcn typcn-chevron-right-outline' },
    { id: 6, className: 'typcn typcn-chevron-right', tooltip: 'typcn typcn-chevron-right' },
    { id: 7, className: 'typcn typcn-clipboard', tooltip: 'typcn typcn-clipboard' },
    { id: 8, className: 'typcn typcn-cloud-storage', tooltip: 'typcn typcn-cloud-storage' },
    { id: 9, className: 'typcn typcn-cloud-storage-outline', tooltip: 'typcn typcn-cloud-storage-outline' },
    { id: 10, className: 'typcn typcn-code-outline', tooltip: 'typcn typcn-code-outline' },
    { id: 11, className: 'typcn typcn-code', tooltip: 'typcn typcn-code' },
    { id: 12, className: 'typcn typcn-coffee', tooltip: 'typcn typcn-coffee' },
    { id: 13, className: 'typcn typcn-cog-outline', tooltip: 'typcn typcn-cog-outline' },
    { id: 14, className: 'typcn typcn-cog', tooltip: 'typcn typcn-cog' },
    { id: 15, className: 'typcn typcn-compass', tooltip: 'typcn typcn-compass' },
    { id: 16, className: 'typcn typcn-delete-outline', tooltip: 'typcn typcn-delete-outline' },
    { id: 17, className: 'typcn typcn-database', tooltip: 'typcn typcn-database' },
    { id: 18, className: 'typcn typcn-css3', tooltip: 'typcn typcn-css3' },
    { id: 19, className: 'typcn typcn-credit-card', tooltip: 'typcn typcn-credit-card' },
    { id: 20, className: 'typcn typcn-contacts', tooltip: 'typcn typcn-contacts' },
    { id: 21, className: 'las la-archive', tooltip: 'typcn typcn-delete' }
]
//Line Awesome Icons
export const Icondata8 = [
    { id: 1, className: 'las la-bell', tooltip: 'las la-bell' },
    { id: 2, className: 'las la-exclamation-circle', tooltip: 'las la-exclamation-circle' },
    { id: 3, className: 'las la-exclamation-triangle', tooltip: 'las la-exclamation-triangle' },
    { id: 4, className: 'las la-arrow-alt-circle-down', tooltip: 'las la-arrow-alt-circle-down' },
    { id: 5, className: 'las la-arrow-alt-circle-up', tooltip: 'las la-arrow-alt-circle-up' },
    { id: 6, className: 'las la-arrow-alt-circle-left', tooltip: 'las la-arrow-alt-circle-left' },
    { id: 7, className: 'las la-arrow-alt-circle-right', tooltip: 'las la-arrow-alt-circle-right' },
    { id: 8, className: 'las la-history', tooltip: 'las la-history' },
    { id: 9, className: 'las la-headphones', tooltip: 'las la-headphones' },
    { id: 10, className: 'las la-tv', tooltip: 'las la-tv' },
    { id: 11, className: 'las la-car-side', tooltip: 'las la-car-side' },
    { id: 12, className: 'las la-envelope', tooltip: 'las la-envelope' },
    { id: 13, className: 'las la-edit', tooltip: 'las la-edit' },
    { id: 14, className: 'las la-map', tooltip: 'las la-map' },
    { id: 15, className: 'las la-cloud-upload-alt', tooltip: 'las la-cloud-upload-alt' },
    { id: 16, className: 'las la-recycle', tooltip: 'las la-recycle' },
    { id: 17, className: 'las la-play', tooltip: 'las la-play' },
    { id: 18, className: 'las la-tv', tooltip: 'las la-tv' },
    { id: 19, className: 'las la-car', tooltip: 'las la-car' },
    { id: 20, className: 'las la-tree', tooltip: 'las la-tree' },
    { id: 21, className: 'las la-archive', tooltip: 'las la-archive' }
]
//Boxicons
export const Icondata9 = [
    { id: 1, className: 'bx bx-home', tooltip: 'bx bx-home' },
    { id: 2, className: 'bx bx-home-alt', tooltip: 'bx bx-home-alt' },
    { id: 3, className: 'bx bx-box', tooltip: 'bx bx-box' },
    { id: 4, className: 'bx bx-medal', tooltip: 'bx bx-medal' },
    { id: 5, className: 'bx bx-file', tooltip: 'bx bx-file' },
    { id: 6, className: 'bx bx-palette', tooltip: 'bx bx-palette' },
    { id: 7, className: 'bx bx-receipt', tooltip: 'bx bx-receipt' },
    { id: 8, className: 'bx bx-table', tooltip: 'bx bx-table' },
    { id: 9, className: 'bx bx-bar-chart-alt', tooltip: 'bx bx-bar-chart-alt' },
    { id: 10, className: 'bx bx-layer', tooltip: 'bx bx-layer' },
    { id: 11, className: 'bx bx-map-alt', tooltip: 'bx bx-map-alt' },
    { id: 12, className: 'bx bx-gift', tooltip: 'bx bx-gift' },
    { id: 13, className: 'bx bx-file-blank', tooltip: 'bx bx-file-blank' },
    { id: 14, className: 'bx bx-lock-alt', tooltip: 'bx bx-lock-alt' },
    { id: 15, className: 'bx bx-error', tooltip: 'bx bx-error' },
    { id: 16, className: 'bx bx-error-circle', tooltip: 'bx bx-error-circle' },
    { id: 17, className: 'bx bx-universal-access', tooltip: 'bx bx-universal-access' },
    { id: 18, className: 'bx bx-message-dots', tooltip: 'bx bx-message-dots' },
    { id: 19, className: 'bx bx-basket', tooltip: 'bx bx-basket' },
    { id: 20, className: 'bx bx-purchase-tag-alt', tooltip: 'bx bx-purchase-tag-alt' },
    { id: 21, className: 'bx bx-camera', tooltip: 'bx bx-camera' }
]
//Tabler Icons
export const Icondata10 = [
    { id: 1, className: 'ti ti-brand-tabler', tooltip: 'ti ti-brand-tabler' },
    { id: 2, className: 'ti ti-activity-heartbeat', tooltip: 'ti ti-activity-heartbeat' },
    { id: 3, className: 'ti ti-alert-octagon', tooltip: 'ti ti-alert-octagon' },
    { id: 4, className: 'ti ti-album', tooltip: 'ti ti-album' },
    { id: 5, className: 'ti ti-antenna-bars-5', tooltip: 'ti ti-antenna-bars-5' },
    { id: 6, className: 'ti ti-armchair', tooltip: 'ti ti-armchair' },
    { id: 7, className: 'ti ti-arrow-big-right', tooltip: 'ti ti-arrow-big-right' },
    { id: 8, className: 'ti ti-arrows-shuffle-2', tooltip: 'ti ti-arrows-shuffle-2' },
    { id: 9, className: 'ti ti-backspace', tooltip: 'ti ti-backspace' },
    { id: 10, className: 'ti ti-color-picker', tooltip: 'ti ti-color-picker' },
    { id: 12, className: 'ti ti-activity', tooltip: 'ti ti-activity' },
    { id: 13, className: 'ti ti-alert-octagon', tooltip: 'ti ti-alert-octagon' },
    { id: 14, className: 'ti ti-apps', tooltip: 'ti ti-apps' },
    { id: 15, className: 'ti ti-align-justified', tooltip: 'ti ti-align-justified' },
    { id: 16, className: 'ti ti-battery', tooltip: 'ti ti-battery' },
    { id: 17, className: 'ti ti-arrows-right-left', tooltip: 'ti ti-arrows-right-left' },
    { id: 18, className: 'ti ti-blur', tooltip: 'ti ti-blur' },
    { id: 19, className: 'ti ti-access-point', tooltip: 'ti ti-access-point' },
    { id: 20, className: 'ti ti-2fa', tooltip: 'ti ti-2fa' },
    { id: 21, className: 'ti ti-3d-cube-sphere', tooltip: 'ti ti-3d-cube-sphere' },
    { id: 22, className: 'ti ti-3d-rotate', tooltip: 'ti ti-3d-rotate' }
]
//Remix Icons
export const Icondata11 = [
    { id: 1, className: 'ri-home-line', tooltip: 'ri-home-line' },
    { id: 2, className: 'ri-mail-line', tooltip: 'ri-mail-line' },
    { id: 3, className: 'ri-briefcase-line', tooltip: 'ri-briefcase-line' },
    { id: 4, className: 'ri-window-line', tooltip: 'ri-window-line' },
    { id: 5, className: 'ri-chat-2-line', tooltip: 'ri-chat-2-line' },
    { id: 6, className: 'ri-chat-settings-line', tooltip: 'ri-chat-settings-line' },
    { id: 7, className: 'ri-edit-line', tooltip: 'ri-edit-line' },
    { id: 8, className: 'ri-layout-line', tooltip: 'ri-layout-line' },
    { id: 9, className: 'ri-code-s-slash-line', tooltip: 'ri-code-s-slash-line' },
    { id: 10, className: 'ri-airplay-line', tooltip: 'ri-airplay-line' },
    { id: 11, className: 'ri-file-line', tooltip: 'ri-file-line' },
    { id: 12, className: 'ri-flag-2-line', tooltip: 'ri-flag-2-line' },
    { id: 13, className: 'ri-send-plane-line', tooltip: 'ri-send-plane-line' },
    { id: 14, className: 'ri-record-mail-line', tooltip: 'ri-record-mail-line' },
    { id: 15, className: 'ri-links-fill', tooltip: 'ri-links-fill' },
    { id: 16, className: 'ri-printer-line', tooltip: 'ri-printer-line' },
    { id: 17, className: 'ri-message-3-line', tooltip: 'ri-message-3-line' },
    { id: 18, className: 'ri-edit-2-line', tooltip: 'ri-edit-2-line' },
    { id: 19, className: 'ri-layout-5-line', tooltip: 'ri-layout-5-line' },
    { id: 20, className: 'ri-code-fill', tooltip: 'ri-code-fill' }
]
//Bootstrap Icons
export const Icondata12 = [
    { id: 1, className: 'bi bi-arrow-left-circle', tooltip: 'bi bi-arrow-left-circle' },
    { id: 2, className: 'bi bi-arrows-move', tooltip: 'bi bi-arrows-move' },
    { id: 3, className: 'bi bi-bag', tooltip: 'bi bi-bag' },
    { id: 4, className: 'bi bi-bar-chart-line', tooltip: 'bi bi-bar-chart-line' },
    { id: 5, className: 'bi bi-basket', tooltip: 'bi bi-basket' },
    { id: 6, className: 'bi bi-bell', tooltip: 'bi bi-bell' },
    { id: 7, className: 'bi bi-book', tooltip: 'bi bi-book' },
    { id: 8, className: 'bi bi-box', tooltip: 'bi bi-box' },
    { id: 9, className: 'bi bi-briefcase', tooltip: 'bi bi-briefcase' },
    { id: 10, className: 'bi bi-brightness-high', tooltip: 'bi bi-brightness-high' },
    { id: 12, className: 'bi bi-calendar', tooltip: 'bi bi-calendar' },
    { id: 13, className: 'bi bi-paint-bucket', tooltip: 'bi bi-paint-bucket' },
    { id: 15, className: 'bi bi-cart-dash', tooltip: 'bi bi-cart-dash' },
    { id: 16, className: 'bi bi-app', tooltip: 'bi bi-app' },
    { id: 17, className: 'bi bi-arrow-repeat', tooltip: 'bi bi-arrow-repeat' },
    { id: 18, className: 'bi bi-arrows-collapse', tooltip: 'bi bi-arrows-collapse' },
    { id: 19, className: 'bi bi-battery', tooltip: 'bi bi-battery' },
    { id: 20, className: 'bi bi-basket3', tooltip: 'bi bi-basket3' },
    { id: 21, className: 'bi bi-bookmark-dash', tooltip: 'bi bi-bookmark-dash' },
    { id: 22, className: 'bi bi-box2', tooltip: 'bi bi-box2' },
    { id: 23, className: 'bi bi-cloud', tooltip: 'bi bi-cloud' },
    { id: 24, className: 'bi bi-calendar4', tooltip: 'bi bi-calendar4' }
]
